<template>
    <v-row no-gutters align="center">
        <v-col cols="3" class="px-1">
            <v-text-field
                key="net_price"
                :value="formatNumber(productPrice.net_price) === 'NaN' ? productPrice.net_price : formatNumber(productPrice.net_price)"
                :error-messages="errors.net_price_error"
                :label="$t('Price')"
                :disabled="disabled"
                outlined
                @change="price_changed"
            />
        </v-col>
        <v-col
            v-if="rangesAvailable"
            cols="3"
            class="px-1"
        >
            <v-text-field
                key="range_until"
                v-model="productPrice.range_until"
                :error-messages="errors.range_until_error"
                :label="$t('Quantity') + ' ' + range_info()"
                :placeholder="range_info()"
                outlined
                :disabled="disabled"
                @input="range_until_changed"
            />
        </v-col>
        <v-col
            v-if="productType === 'fixed_price'"
            cols="3"
            class="px-1"
        >
            <v-text-field
                v-model="productPrice.quantity"
                :error-messages="errors.quantity_error"
                :label="$t('Quantity')"
                :disabled="disabled"
                outlined
            />
        </v-col>
        <v-col v-if="showProductUnitSelect" cols="3" class="px-1" style="padding-bottom: 14px">
            <dropdown
                :items="units"
                :selected="units.filter(x => x.value === productPrice.unit)"
                name-key="text"
                value-key="value"
                show-selected-first
                :disabled="disabled"
                :label="$t('Calculate')"
                @input="productPrice.unit = $event.value"
            />
        </v-col>
        <v-col cols="2">
            <v-text-field
                key="range_until"
                v-model="productPrice.unit_label"
                class="unit-field"
                :error-messages="errors.unit_label_error"
                :placeholder="productPrice.unit"
                outlined
                :disabled="disabled"
                :label="$t('Unit')"
            >
                <template #label>
                    <div>
                        {{ $t('Unit') }}
                    </div>
                    <v-tooltip
                        bottom
                        v-if="!disabled"
                    >
                        <template v-slot:activator="{ on }">
                            <div
                                class="ml-1 d-flex"
                                v-on="on"
                            >
                                <icon
                                    size="14"
                                    icon="HelpCircle"
                                />
                            </div>
                        </template>
                        <div>
                            {{ $t("Unit will be translated to client language") }}
                        </div>
                    </v-tooltip>
                </template>
            </v-text-field>
        </v-col>
        <v-col v-if="rangesAvailable && rowIndex >= 1 && !disabled" class="text-right" cols="1">
            <v-btn icon text color="grey" @click="delete_row">
                <v-icon :size="24">delete</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import {cleanNumber, formatNumber} from "../../plugins/formatting";
import {computed} from "@vue/composition-api";
import {$t} from "../../i18n";

export default {
    name: "ProductPriceRow",
    props: {
        periodPrices: {
            type: Array,
            required: true
        },
        productPrice: {
            type: Object,
            required: true
        },
        units: {
            type: Array,
            required: true
        },
        productType: {
            type: String,
            required: true
        },
        rangesAvailable: Boolean,
        periodIndex: {
            type: Number,
            required: true
        },
        rowIndex: {
            type: Number,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Object,
            default: null
        }
    },
    setup(props, ctx) {
        const range_until_changed = data => {
            props.productPrice.range_until = cleanNumber(data);
        };
        const price_changed = data => {
            props.productPrice.net_price = cleanNumber(data);
        };
        const delete_row = () => {
            return ctx.emit("delete_row", props.periodIndex, props.rowIndex);
        };

        const range_info = () => {
            try {
                let r1 = 0;
                let r2;
                if (props.rowIndex) {
                    r1 = props.periodPrices[props.rowIndex - 1].range_until;
                    r1 = Math.round(parseInt(("" + r1).split(" ").join("")))  // trim spaces, number
                }
                r2 = props.periodPrices[props.rowIndex].range_until;
                r2 = Math.round(("" + r2).split(" ").join(""))  // trim spaces, number
                if (r1) r1 = parseInt(r1); else r1 = 0; // +1
                if (!r2) r2 = '∞'; else r2 = Math.round((r2) * 100, 2) / 100; // -0.01
                return (isNaN(r1) ? 0 : r1) + ' - ' + r2;
            } catch (err) {
                console.error('range_info', err)
            }
            return '?';
        };

        const showProductUnitSelect = computed(() => {
            return props.units.length > 1
        })

        return {
            range_until_changed,
            price_changed,
            delete_row,
            range_info,
            showProductUnitSelect,
            formatNumber
        };
    }
};
</script>

<style scoped lang="scss">
.v-input ::v-deep input {
    font-size: 14px !important;
}

::v-deep .v-input input {
    font-size: 14px !important;
}

.v-select ::v-deep .v-select__selection {
    font-size: 12px !important;
}

.unit-field {
    ::v-deep {
        input {
            &::placeholder {
                color: var(--v-main-base) !important;
                opacity: 1 !important;
            }

            &:disabled {
                opacity: 0.4 !important;
            }
        }

        .v-label {
            display: flex;
            align-items: center;
            pointer-events: unset;
        }
    }
}

</style>